import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Boleto} from '../../models';
import {environment} from 'src/environments/environment';
import PouchDB from 'pouchdb-browser';
import {from, Observable, Subject} from 'rxjs';
// import {ActionUserLocaldbService} from './action-user-localdb.service';
// import {ACTIONS_USER_DB} from '../../utils/enum';

@Injectable({
  providedIn: 'root'
})
export class ScanBoletoService {
  private db: any;
  private ENDPOINT = environment.ENDPOINTS.BOLETO;

  counterDocs$ = new Subject<number>();
  actualCount = 0;

  constructor(private http: HttpClient) {
    this.db = new PouchDB('db_scan_boletos');
    this.getInfoLocal();
  }

  saveboleto(boleto: Boleto) {

    return this.http.put<any>(`${this.ENDPOINT}/${boleto.id}`,boleto );

  }

  saveBoletoLocal(dataSchema: Boleto): Observable<Boleto> {
    console.log('no hay conexión a red');
    let result: Promise<Boleto> = new Promise((resolve, reject) => {
      this.db.get(dataSchema._id)
        .then(async (doc: any) => {
          console.log('encontrado y actualizado');
          delete dataSchema._id;
          doc = Object.assign(doc, dataSchema);
          try {
            let result = await this.db.put(doc);
            resolve(result);
          } catch (err) {
            reject(err);
          }

        }).catch(async () => {
        try {
          let result = await this.db.post(dataSchema);
          resolve(result);
          console.log('se creo new register');
          this.actualCount = this.actualCount + 1;
          console.log(this.actualCount);
          this.counterDocs$.next(this.actualCount);
        } catch (err) {
          reject(err);
        }
      });
    });

    return from(result);
  };

  public deleteBoletoLocal(id: number) {
    return this.db.get(id)
      .then(doc => {
        return this.db.remove(doc);
      })
      .then(
        _ => {
          this.actualCount = this.actualCount - 1;
          console.log(this.actualCount);
          this.counterDocs$.next(this.actualCount);
          return true;
        }
      )
      .catch(err => {
        console.log(err);
      });
  }

  public getInfoLocal() {
    this.db.info().then(data => {
      this.actualCount = data.doc_count;
      console.log(this.actualCount);
      this.counterDocs$.next(this.actualCount);
    });
  }


  public getAll(): Promise<Boleto[]> {
    return new Promise((resolve, reject) => {
      this.db.allDocs({
        include_docs: true
      })
        .then(data => {
          let eventsboleto = data.rows.map(
            (row: any): Boleto => {

              return ({
                _id: row.doc._id,
                id: row.doc.id,
                estatus: row.doc.estatus,
                //codigo_qr: row.doc.codigo_qr,
                //fecha_emision: row.doc.fecha_emision,
                fecha_cruce: row.doc.fecha_cruce,
                no_boleto: row.doc.no_boleto,
                //monto: row.doc.monto,
                id_corte_usuario: row.doc.id_corte_usuario,
                // transportista: row.doc.transportista,
                // tipo: row.doc.tipo,
                // clasificacion: row.doc.clasificacion,
              });

            }
          );
          resolve(eventsboleto);
        }).catch(err => {
        reject(err);
      });
    });
  }


}
